<template>
  <Teleport to="body">
    <div class="pointer-events-none absolute -z-10 inset-x-0 top-0 overflow-x-hidden h-[1500px]">
      <img ref="imgRef" :src="XS2Mark" class="absolute top-45 left-1/2 min-w-[450px] max-w-1/2" />
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { gsap } from "gsap";
import XS2Mark from "@/assets/images/xs2_logo_mark.svg?inline";

const imgRef = ref<HTMLImageElement | null>(null);

onMounted(() => {
  gsap.from(imgRef.value, {
    x: 100,
    opacity: 0,
    duration: 0.8,
    delay: 1,
    ease: "power2.out",
  });
});
</script>
